import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { ApiClient } from '@sfs-projects/sfs-fc-api-sdk';
import env from "@/utils/env";

const perPage = env.VUE_APP_PER_PAGE;

interface DebtorResponse {
  Paginate: {
    currentPage: number;
    perPage: number;
    totalRow: number;
  };
  debtorList: Array<any>;
  debtorTrackingList: Array<any>;
}

@Module({ namespaced: true })
class DebtorsModule extends VuexModule {
  public debtorData: Array<any> = [];
  public debtorTrackingData: Array<any> = [];
  public lastKey: any;

  @Mutation
  public setDebtorData(list: Array<any>): void {
    this.debtorData = list;
  }

  @Mutation
  public setDebtorLastKey(lastKey: any): void {
    this.lastKey = lastKey;
  }

  @Action
  public updateDebtors(params: any): void {
    this.context.commit('setDebtorData', params)
  }

  @Action
  public updateLastKey(params: any): void {
    this.context.commit('setDebtorLastKey', params)
  }
  @Mutation
  public addDebtorList(list: Array<any>): void {
    list.forEach(item => {
      const index = this.debtorData.findIndex(x => x.Debtor == item.Debtor)
      if (index === -1) {
        this.debtorData.push(item);
      }
    })
  }

  @Mutation
  public addDebtorTrackingList(list: Array<any>): void {
    this.debtorTrackingData = list
  }

  @Action
  public async getItemPerPage(params: any): Promise<any> {
    params.page = params.page ?? 1; //set page default = 1 if page not send
    return new Promise((resolve, reject) => {
      const totalpage = this.debtorData.length / perPage;
      if (params.page >= totalpage && this.lastKey) {
        //@TODO : query more if not last key
        params.filter.LastKey = this.lastKey;
        ApiClient.post('debtors/search', params.filter).then((response: any) => {
          const debtorList = response.data;
          //keep data AND lastkey in state
          this.context.commit('addDebtorList', debtorList)
          this.context.commit('setDebtorLastKey', response.LastKey)
          const result = {
            Paginate: {
              currentPage: params.page,
              perPage: perPage,
              totalRow: this.debtorData.length
            },
            debtorList: this.debtorData.slice(perPage * (params.page - 1), perPage * (params.page - 1) + perPage)
          }
          resolve(result);
        }, error => {
          reject(error);
        });
      } else {
        const result = {
          debtorList: this.debtorData.slice(perPage * (params.page - 1), perPage * (params.page - 1) + perPage)
        }
        resolve(result);
      }
    })
  }


  @Action
  public async retrieveDebtors(params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      //@TODO: check if filter data already have in state
      // if state have data then return that data
      ApiClient.post('debtors/search', params).then((response: any) => {
        const debtorList = response.data;
        //keep data AND lastkey in state
        this.context.dispatch('updateDebtors', debtorList)
        this.context.commit('setDebtorLastKey', response.LastKey)
        const result: any = {
          Paginate: {
            currentPage: 1,
            perPage: perPage,
            totalRow: this.debtorData.length
          },
          debtorList: debtorList.slice(0,perPage) // get first perpage item
        }
        resolve(result);
      }, error => {
        reject(error);
      });
    })
  }

  @Action
  public async retrieveDebtorById(debtorId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.debtorData.length > 0) {
        const debtor = this.debtorData.find((debtor) => {
          return debtor.Debtor === debtorId;
        });
        this.context.dispatch('updateDebtors', debtor);
        resolve(debtor);
      }
      const urlApi = 'debtors/' + debtorId + '?AdmNr=99000';
      ApiClient.get(urlApi).then((value: any) => {
        if (value.success) {
          const result = value.data[0];
          this.context.dispatch('updateDebtors', result);
          resolve(result);
        }
        reject(value);
      }, error => {
        reject(error);
      });
    })
  }

  @Action
  public async addDebtor(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const urlApi = 'debtors';
      ApiClient.post(urlApi, data).then((value: any) => {
        if (value.success) {
          const result = value.data[0];
          this.context.dispatch('updateDebtors', result);
          resolve(result);
        }
        resolve({ Error: value.data });
      }, (error) => {
        resolve({ Error: error.response.data });
      });
    })
  }

  @Action
  public async editDebtor(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const urlApi = 'debtors/' + data.Debtor;
      delete data.Debtor;
      ApiClient.patch(urlApi, data).then((value: any) => {
        if (value.success) {
          const result = value.data[0];
          this.context.dispatch('updateDebtors', result);
          resolve(result);
        }
        resolve({ Error: value.data });
      }, error => {
        resolve({ Error: error.response.data });
      });
    })
  }


  @Action
  public async retrieveDebtorsTracking(params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      //@TODO: check if filter data already have in state
      // if state have data then return that data
      ApiClient.post('debtors/tracking/search', params).then((response: any) => {
        const debtorTrackingList = response.data;
        //keep data AND lastkey in state
        this.context.commit('addDebtorTrackingList', debtorTrackingList); 
        const result: any = {
          Paginate: {
            currentPage: 1,
            perPage: perPage,
            totalRow: debtorTrackingList.length
          },
          debtorTrackingList: debtorTrackingList.slice(0,perPage) // get first perpage item
        }
        resolve(result);
      }, error => {
        reject(error);
      });
    })
  }


  @Action
  public async getTrackingPerPage(params: any): Promise<any> {
    params.page = params.page ?? 1; //set page default = 1 if page not send
    return new Promise((resolve, reject) => {
      const totalpage = this.debtorTrackingData.length / perPage;
      if (params.page >= totalpage && this.lastKey) {
        //@TODO : query more if not last key
        params.filter.LastKey = this.lastKey;
        ApiClient.post('debtors/tracking/search', params.filter).then((response: any) => {
          const debtorTrackingList = response.data;
          this.context.commit('addDebtorTrackingList', debtorTrackingList);
          const result = {
            Paginate: {
              currentPage: params.page,
              perPage: perPage,
              totalRow: this.debtorTrackingData.length
            },
            debtorTrackingList: this.debtorTrackingData.slice(perPage * (params.page - 1), perPage * (params.page - 1) + perPage)
          }
          resolve(result);
        }, error => {
          reject(error);
        });
      } else {
        const result = {
          debtorTrackingList: this.debtorTrackingData.slice(perPage * (params.page - 1), perPage * (params.page - 1) + perPage)
        }
        resolve(result);
      }
    })
  }
}
export default DebtorsModule